module.exports = __webpack_public_path__ + "static/page-layer-bg4-8a7ef1b003864bfb98a4d1b123135599.jpg";